/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {activateDigitalWallet} from '../api'

export const useMutationActivateDigitalWallet = createReactQueryMutationHook('activateDigitalWallet', activateDigitalWallet)
